import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IProduct, ProductSearch } from 'src/app/models/products/product';
import { IPreference } from 'src/app/models/users/userProfile';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class DashboardCardComponent implements OnInit {
  @Input() data!: IProduct;
  @Input() latestAction: string | null = null;
  @Output() reload = new EventEmitter();

  isImageLoaded = false;
  currentConfigDate!: IPreference;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.currentPreference.subscribe((res) => {
      this.currentConfigDate = res;
    });
  }

  loadImage() {
    this.isImageLoaded = true;
  }
  onEdit() {
    this.router.navigateByUrl(
      `batches/${this.data.batchId}/products/${this.data.id}`
    );
  }

  getLinkImage() {
    return ProductsService.getLinkImage(this.data.thumbnailUri!);
  }
}
